import { ReactElement, useContext, useEffect, useRef, useState } from "react";
import "./Cover.css";
import { currency } from "../../utilities/misc";
import { LocaleContext } from "../../AppProvider";

const Cover = ({
  children,
  className,
  onClick,
  labelled
}: {
  children: ReactElement | ReactElement[];
  className: string;
  onClick?: () => void;
  labelled?: number;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const [left, setLeft] = useState(`second`);

  const coverRef = useRef<HTMLDivElement>(null);
  const reLu = (num: number) => {
    if (num < 0) {
      return 0;
    } else {
      return num;
    }
  };

  useEffect(() => {
    const value =
      coverRef.current?.getBoundingClientRect().left &&
      coverRef.current?.getBoundingClientRect().left >= 84
        ? `calc(-1 * var(--width) / 2 - 0.5rem)`
        : `${
            (-1 *
              reLu(
                (coverRef.current?.getBoundingClientRect().left || 0) - 16
              )) /
            16
          }rem`;
    setLeft(value);
    const changeLeft = () => {
      const value =
        coverRef.current?.getBoundingClientRect().left &&
        coverRef.current?.getBoundingClientRect().left >= 84
          ? `calc(-1 * var(--width) / 2 - 0.5rem)`
          : `${
              (-1 *
                reLu(
                  (coverRef.current?.getBoundingClientRect().left || 0) - 16
                )) /
              16
            }rem`;
      setLeft(value);
    };
    window.addEventListener(`resize`, changeLeft);
    return () => {
      window.removeEventListener(`resize`, changeLeft);
    };
  }, []);

  return (
    <div ref={coverRef} className={`cover_wrap ${className}`}>
      {labelled ? (
        <div
          style={{
            left
          }}
          className="cover_wrap_alert center"
        >
          {t("SAVE {{amount}}", {
            "{{amount}}": currency(labelled.toFixed(2), locale)
          })}
        </div>
      ) : (
        <></>
      )}
      <div onClick={onClick ? onClick : () => {}} className="inner">
        {children}
      </div>
    </div>
  );
};

export default Cover;
